/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';
import { Empty, Pagination, Table } from 'antd';
import tableColumns from './tableColumns';
import StoreInventoryContext from '../../../contexts/store-inventory-context/StoreInventoryProvider';
import UserContext from '../../../contexts/user-context/UserProvider';
import getAllInventoriesApi from '../../../apis/store-apis/inventory-apis/getAllInventoryApi';
import useCustomApiRequest from '../../../custom-hooks/useCustomApiRequest';
import storeRouterLinks from '../../../components/app/store-routes/storeRouterLinks';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const PageTable = () => {
  const { t } = useTranslation();
  const { user } = useContext(UserContext);
  const {
    isLoading,
    setIsLoading,
    setModalOpened,
    allFetchedInventories,
    fetchCount,
    setAllFetchedInventories,
    setFetchCount,
    setSelectedInventory,
    tablePagination,
    selectedReceipt,
    setSelectedReceipt,
    allFetchedReceipts,
    setAllFetchedReceipts,
    selectedReceiptModalOpened,
    setSelectedReceiptModalOpened
  } = useContext(StoreInventoryContext);

  const [tableDataSource, setTableDataSource] = useState([]);
  const mapDataSource = (data) => {
    return data.map((obj, index) => ({
      ...obj,
      key: obj.id,
      index: index + 1,
      name: obj?.name ? obj.name : '',
      title: obj?.title ? obj.title : ''
    }));
  };
  const customApiRequest = useCustomApiRequest();
  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      setIsLoading(true);
      customApiRequest(
        getAllInventoriesApi(user?.token),
        (res) => {
          setIsLoading(false);
          if (res?.data?.data) {
            const data = res.data.data;
            setAllFetchedInventories(data);
          }
        },
        (errror) => {
          setIsLoading(false);
        }
      );
    }

    return () => {
      isMounted = false;
    };
  }, [fetchCount]);

  // map all data to dataSource
  useEffect(() => {
    let isMounted = true;

    if (allFetchedInventories?.length >= 0) {
      const mappedData = mapDataSource(allFetchedInventories);
      if (isMounted) {
        setTableDataSource(mappedData);
      }
    }

    return () => {
      isMounted = false;
    };
  }, [fetchCount, allFetchedInventories, allFetchedInventories?.length]);
  const history = useHistory();

  return (
    <>
      <Table
        locale={{
          emptyText: (
            <Empty description={false}>
              {t('Inventory.WarehouseInventory.noDataAvailable')}
            </Empty>
          )
        }}
        //pagination={{ defaultPageSize: 5, hideOnSinglePage: true }}
        pagination={false}
        className="antd-custom-table"
        dataSource={tableDataSource}
        columns={tableColumns(
          allFetchedInventories,
          setModalOpened,
          setFetchCount,
          setSelectedInventory,
          setIsLoading,
          t,
          user?.token,
           setSelectedReceiptModalOpened,
  setSelectedReceipt,
  allFetchedReceipts,
  null,
        )}
        loading={isLoading}
        // scroll={{ x: 400 }}
        footer={false}
      />
      {tablePagination && (
        <Pagination
          style={{ display: 'flex', justifyContent: 'center' }}
          defaultCurrent={1}
          current={tablePagination.current_page}
          pageSize={tablePagination.per_page}
          total={tablePagination.total}
          // itemRender={itemRender}
          onChange={(page, pageSize) => {
            setFetchCount((prev) => prev + 1);
            history.push(`${storeRouterLinks?.storeInventory}?page=${page}`);
          }}
          hideOnSinglePage={true}
        />
      )}
    </>
  );
};

export default PageTable;
